import { SxProps } from "@mui/system";

export const inputField: SxProps = {
    display: "flex",
    m: "0 auto 25px auto",
    width: "50%",
};